<template>
  <div class="page-layout-container">
    <div
      ref="pageLayoutScroll"
      v-if="isMonitorScroll"
      v-scroll.self="scrollThrottle"
      class="tab-content-box MonitorScroll"
      :style="`background-color:${contentBgcolor || $vuetify.theme.themes.light.background}`"
    >
      <slot v-bind:pageScrollTop="pageScrollTop"></slot>
    </div>
    <div
      ref="pageLayoutScroll"
      v-else
      class="tab-content-box"
      v-scroll.self="scrollThrottle"
      :style="`background-color:${contentBgcolor || $vuetify.theme.themes.light.background}`"
    >
      <slot></slot>
    </div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="36"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Appbar from '@c/layout/Appbar'
import BottomTab from '@c/layout/BottomTab'
export default {
  provide() {
    return {
      toTop: this.toTop
    }
  },
  components: {
    Appbar,
    BottomTab
  },
  data() {
    return {
      pageScrollTop: 0,
      scrollThrottle: this.$tools.throttle(50, e => {
        this.pageScrollTop = e.target.scrollTop
        this.$store.commit('app/setPageScrollTop', this.pageScrollTop)
      })
    }
  },
  props: {
    contentBgcolor: {
      type: [String, Boolean],
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    isMonitorScroll: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toTop() {
      try {
        this.$refs.pageLayoutScroll.firstChild.scrollIntoView({
          behavior: 'smooth'
        })
      } catch {}
    }
  }
}
</script>
<style lang="scss" scoped>
.page-layout-container {
  height: 100%;
  display: flex;
  flex-direction: column;

  .tab-content-box {
    flex: 1;
    overflow: auto;
  }

  .tab-nav-icon {
    font-size: 18px;
  }
}
</style>
